import { useAdvertListData } from '@edikk-edikk/country-frontend';
import { apiAdvertListToggleIsFavorite } from '#advertList/api/api-advert-list-toggle-is-favorite';
import { useAppDispatch } from '#components/redux/hooks';
import { useApi } from '#hooks/use-api';
import { apiAdvertFavoriteRemoveAdvert } from '#advertFavorite/api';

const useClickLogicForFavoriteToggle = () => {
  const advertListData = useAdvertListData();
  const dispatch = useAppDispatch();
  const api = useApi();
  const [add] = api.getApiAdvertFavorite().useLazyAddQuery();
  const [remove] = api.getApiAdvertFavorite().useLazyRemoveQuery();

  return async (id: number, isFavorite: boolean) => {
    const cityId = advertListData.getCityId();
    const categoryId = advertListData.getCategoryId();
    const areaId = advertListData.getAreaId();

    if (isFavorite) {
      await remove(id);
      apiAdvertListToggleIsFavorite(api, id, cityId, categoryId, areaId, dispatch);
      apiAdvertFavoriteRemoveAdvert(api.getApiAdvertFavorite(), id, dispatch);
    } else {
      await add(id);
      apiAdvertListToggleIsFavorite(api, id, cityId, categoryId, areaId, dispatch);
    }
  };
};

export { useClickLogicForFavoriteToggle };
